
















import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { env } from '@ivy/fts/envInfo/envInfo'
import * as utils from '@ivy/fts/utils'

@Component
export default class InviteMore extends Vue {
  @Prop() attendInfo: any
  @Prop() publicInfo: any
  @Prop() isPhysical: boolean
  @Prop() status: any
  @Prop() activityId: any
  @Prop() invitedId: any
  @Prop() myTeamId: any
  @Prop() memId: any
  //是否是队长1是 2不是
  @Prop() userType: any
  @Prop() isConfirmed: boolean
  leftTime: any = '00天00:00:00'
  showLeft: boolean = false
  need_num: number = 0
  btn_text: any = ''
  endTime: any
  leftText: any = ''
  limitTime: any
  notFailed: boolean = false
  inviteList: any = []
  nologinList: any = []
  last_timediffer: number = 0
  // 队长
  leader: any
  canClick: boolean = true
  leftCount = 0
  // 当前阶梯
  nowStage = 1
  // 当前每阶梯人数
  stageTable = {}

  @Watch('attendInfo')
  async onShowChange(val) {
    this.initTeamInfo()
  }
  @Watch('status')
  async onstatusChange(val) {
    this.initTeamInfo()
  }
  @Watch('isConfirmed')
  async onComfirmChange(val) {
    this.initTeamInfo()
  }
  async created() {
    this.initTeamInfo()
  }
  //根据阶梯处理邀请的数据 分阶梯存贮
  initInivteInfo(data, stage) {
    if (!this.stageTable[stage]) {
      this.stageTable[stage] = []
    }
    this.stageTable[stage].push(data)
  }
  async initTeamInfo() {
    this.inviteList = []
    this.nologinList = []
    if (this.attendInfo) {
      for (let team of this.attendInfo) {
        if (
          team.is_organizer ||
          (team.status !== 'no_login' && team.is_login)
        ) {
          this.inviteList.push(team)
          if (team.is_organizer) {
            this.initInivteInfo(team, 0)
            //当前阶梯取队长的阶梯
            this.nowStage = team.stage
          } else {
            this.initInivteInfo(team, team.stage)
          }
        } else {
          this.nologinList.push(team)
        }
      }
    }
    this.limitTime = this.publicInfo.config.success_time
    this.endTime = this.publicInfo.end_time.replace(/-/g, '/')
    this.initBtnState()
    this.leftCount =
      this.publicInfo.config.stage_info[this.nowStage] &&
      +this.publicInfo.config.stage_info[this.nowStage].vir_stage_limit
  }
  //初始化按钮状态
  initBtnState() {
    this.showLeft = false
    this.notFailed = true
    if (+new Date() < +new Date(this.publicInfo.end_time.replace(/-/g, '/'))) {
      if (
        !this.publicInfo.config.stage_info[this.publicInfo.config.stage_num] ||
        !this.publicInfo.config.stage_info[this.publicInfo.config.stage_num]
          .stage_limit
      ) {
        //最后一阶的奖励没有了 活动直接结束
        this.notFailed = false
        this.btn_text = '活动已结束'
        return
      }
      //结束时间未到
      //加入当前进来的组队
      if (this.myTeamId) {
        //如果当前队伍的阶梯奖励还有
        if (
          this.publicInfo.config.stage_info[this.nowStage] &&
          this.publicInfo.config.stage_info[this.nowStage].stage_limit
        ) {
          if (this.userType == 1) {
            if (this.status === 'TEAM_HAS_SUCCESS') {
              if (this.isConfirmed) {
                this.canClick = false
                this.btn_text = '组队成功'
                return
              }
              this.btn_text = !this.isPhysical
                ? '组队成功'
                : '填写/修改收货地址'
            } else if (this.status === 'TEAM_IS_WAITING') {
              this.showLeft = true
              //当前阶梯还需邀请数=当前阶梯总数-当前阶梯内已有人数
              this.need_num =
                this.publicInfo.config.stage_info[this.nowStage]
                  .stage_need_num -
                ((this.stageTable[this.nowStage] &&
                  this.stageTable[this.nowStage].length) ||
                  0)
              if (this.nowStage == 1) {
                this.btn_text = `再邀请${this.need_num}人免费领`
              } else {
                this.btn_text = `再邀请${this.need_num}人可继续领`
              }
            } else if (this.status === 'TEAM_HAS_FAIL') {
              this.showLeft = true
              this.btn_text = '重新发起组队'
            } else {
              this.showLeft = true
              this.btn_text = '发起组队'
            }
          } else if (this.userType == 2) {
            if (this.status === 'TEAM_HAS_SUCCESS') {
              //已确认地址 发起组队
              if (this.isConfirmed) {
                this.showLeft = true
                this.btn_text = '发起组队'
                return
              }
              this.btn_text = !this.isPhysical
                ? '发起组队'
                : '填写/修改收货地址'
            } else if (this.status === 'TEAM_IS_WAITING') {
              //是队员 显示发起组队，到底是否能发起放到按钮点击里处理
              this.showLeft = true
              this.btn_text = '发起组队'
            } else if (this.status === 'TEAM_HAS_FAIL') {
              this.showLeft = true
              this.btn_text = '发起组队'
            } else {
              this.showLeft = true
              this.btn_text = '发起组队'
            }
          }
        } else {
          //奖励没有了 活动已结束
          this.notFailed = false
          this.btn_text = '活动已结束'
        }
      } else {
        this.showLeft = false
        //还未加入该组队
        if (this.invitedId && this.status === 'TEAM_IS_WAITING') {
          //邀请人当前的奖励已无 活动结束
          if (
            this.publicInfo.config.stage_info[this.nowStage] &&
            this.publicInfo.config.stage_info[this.nowStage].stage_limit
          ) {
            this.btn_text = '加入组队免费领'
            this.showLeft = true
          } else {
            this.btn_text = '活动已结束'
            this.notFailed = false
          }
        } else {
          if (
            !this.publicInfo.config.stage_info[1] ||
            !this.publicInfo.config.stage_info[1].stage_limit
          ) {
            this.btn_text = '活动已结束'
            this.showLeft = false
            this.notFailed = false
          } else {
            this.btn_text = '发起组队'
            this.showLeft = true
          }
        }
      }
      if (this.showLeft) {
        this.cutDownTime()
      }
    } else {
      //时间已结束
      this.btn_text = '活动已结束'
      this.notFailed = false
    }
  }
  //判断当前是否登录过引导app true 未登录 false  已登录
  getIsNoLogin() {
    let nologinList = this.attendInfo.filter(
      team => team.status == 'no_login' && !team.is_organizer
    )
    if (nologinList.findIndex(el => el.mem_id === +this.memId) !== -1) {
      return true
    }
    return false
  }
  async handlerAction() {
    if (this.canClick) {
      this.$emit('handlerAction')
    }
  }
  async cutDownTime() {
    let timediff: any
    if (
      this.myTeamId &&
      this.userType === 1 &&
      this.status === 'TEAM_IS_WAITING'
    ) {
      //队长发起后显示内容
      this.leftText = '组队时间仅剩'
      let createTime =
        this.inviteList.length &&
        new Date(this.inviteList[0].create_time.replace(/-/g, '/')).getTime()
      let endTime = new Date(this.endTime).getTime()
      if (
        this.inviteList.length &&
        this.limitTime * 3600 < (endTime - createTime) / 1000
      ) {
        timediff =
          this.limitTime * 3600 - (new Date().getTime() - createTime) / 1000
      } else {
        timediff = (endTime - new Date().getTime()) / 1000
      }
    } else {
      //队员可发起组队显示内容 或者还未加入组队可发起组队 或者可重新发起组队显示的内容
      this.leftText = '活动时间仅剩'
      timediff =
        (new Date(this.endTime).getTime() - new Date().getTime()) / 1000
    }

    if (+timediff <= 0 && +this.last_timediffer > 0) {
      this.last_timediffer = 0
      window.location.reload()
      return
    } else if (+timediff > 0) {
      this.last_timediffer = 1
    }
    let day: number = Math.floor(timediff / 86400)
    let hour: number = Math.floor((timediff / 3600) % 24)
    let minutes: number = Math.floor((timediff / 60) % 60)
    let second: number = Math.floor(timediff % 60)
    if (timediff) {
      this.leftTime = `${this.addZero(day)}天${this.addZero(
        hour
      )}:${this.addZero(minutes)}:${this.addZero(second)}`
      await utils.sleep(1000)
      this.cutDownTime()
    } else {
      this.leftTime = '00天00:00:00'
    }
  }
  addZero(value) {
    return value < 10 ? `0${value}` : value
  }
}
